<template>
  <div>
    <base-header class="pb-6" style="background-color: #248dc1 !important;">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">{{$store.state.user.sponsor_branch}}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right"></div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-md-12">
          <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
            <template slot="header">
              <h3 class="mb-0">Sucursal: {{$store.state.user.sponsor_branch}}</h3>
              <p class="text-sm mb-0"></p>
            </template>
            <div>
              <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                <el-select @input="fetchData" class="select-primary pagination-select" v-model="perPage" placeholder="Per page">
                  <el-option
                    class="select-primary"
                    v-for="item in perPageList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <div class="block">
                    <span class="demonstration">Fechas &nbsp;</span>
                    <el-date-picker
                    v-model="dateRangeFilter"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="-"
                    start-placeholder="Desde"
                    end-placeholder="Hasta"
                    @change="fetchData"
                    :picker-options="pickerOptions2">
                    </el-date-picker>
                </div>
                <div>
                  <base-input v-model="search"
                    prepend-icon="fas fa-search"
                    @keyup.enter="fetchData"
                    placeholder="Realizar búsqueda...">
                  </base-input>
                </div>
              </div>
              <div class="table-responsive">
                <el-table :data="tableData"
                          row-key="id"
                          class="table-responsive table"
                          header-row-class-name="thead-light">
                  <el-table-column
                    v-for="column in tableColumns"
                    :key="column.label"
                    v-bind="column"
                    :sortable="false"
                    :width="column.type == 'selection' ? '40px' : (column.label == 'id' ? '90px' : '200px')"
                  >
                  </el-table-column>
                  <el-table-column :sortable="false" min-width="200px" align="right" label="fecha_confirmacion">
                    <div slot-scope="{$index, row}" class="d-flex">
                      {{$moment(row['fecha_confirmacion']).format('DD-MM-YYYY HH:mm')}}
                    </div>
                  </el-table-column>
                  <el-table-column :sortable="false" min-width="200px" align="right" label="Venta">
                    <div slot-scope="{$index, row}" class="d-flex">
                      <base-button
                        v-if="row.requiere_venta"
                        @click.native="ingresarNroVenta(row.id)" 
                        class="edit"
                        type="success"
                        size="sm"
                        icon
                      >
                        <i class="text-white ni ni-collection"></i> Número de venta
                      </base-button>
                    </div>
                  </el-table-column>
                  <el-table-column :sortable="false" min-width="180px" align="right" label="Firma">
                    <div slot-scope="{$index, row}" class="d-flex">
                      <base-button
                        v-if="row.requiere_firma"
                        @click.native="ingresarFirma(row.id)"
                        class="edit"
                        type="primary"
                        size="sm"
                        icon
                      >
                        <i class="text-white ni ni-ruler-pencil"></i> Ingresar firma
                      </base-button>
                    </div>
                  </el-table-column>
                  <el-table-column :sortable="false" min-width="180px" align="right" label="Propuesta">
                    <div slot-scope="{$index, row}" class="d-flex">
                      <base-button
                        @click.native="verContrato(row.id)"
                        class="edit"
                        type="default"
                        size="sm"
                        icon
                      >
                        <i class="text-white fa fa-file"></i> Ver propuesta
                      </base-button>
                    </div>
                  </el-table-column>
                  <el-table-column :sortable="false" min-width="180px" align="right" label="Acciones">
                    <div slot-scope="{$index, row}" class="list-group list-group-flush w-100 align-items-stretch">
                      <base-button
                        style="margin-right: 0rem;"
                        @click.native="confirmarVenta(row.id)"
                        class="edit"
                        type="info"
                        size="sm"
                        icon
                        :disabled="!row.confirmar"
                      >
                        <i class="text-white fa fa-arrow-right"></i> Confirmar
                      </base-button>
                      &nbsp;
                      <base-button
                        @click.native="$emit('loadModalEditVenta', row.id)"
                        class="edit"
                        type="warning"
                        size="sm"
                        icon
                        :disabled="!$can('update', 'ventas') || row.estado != 'TERMINADO'"
                      >
                        <i class="text-white ni ni-settings"></i> Editar
                      </base-button>
                    </div>
                  </el-table-column>
                  <el-table-column :sortable="false" min-width="180px" align="right" label="Eliminar">
                    <div slot-scope="{$index, row}" class="list-group list-group-flush">
                      <base-button
                        style="margin-right: 0rem;"
                        @click.native="eliminarVenta(row)"
                        class="edit"
                        type="danger"
                        size="sm"
                        icon
                      >
                        <i class="text-white fa fa-trash"></i>
                      </base-button>
                    </div>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                <el-pagination
                    :current-page.sync="currentPage"
                    layout="prev, pager, next"
                    :total="totalPages"
                    @current-change="fetchData">
                </el-pagination>
                <!--
              <base-pagination
                class="pagination-no-border"
                v-model="currentPage"
                :per-page="perPage"
                :total="totalPages"
                @change="fetchData"
              >
              </base-pagination>
              -->
            </div>
          </card>
        </div>
      </div>
    </div>
    <modal-pdf ></modal-pdf>
    <modal-firma @firmaSuccess="fetchData"></modal-firma>
    <ingresar-nro-venta></ingresar-nro-venta>
    <modal-edit-venta @successSending="fetchData" ></modal-edit-venta>
  </div>
</template>
<script>    
  // Components
  import BaseProgress from '@/components/BaseProgress';
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import StatsCard from '@/components/Cards/StatsCard';

  // Tables
  import LightTable from '@/views/Dashboard/LightTable';
  import SocialTrafficTable from '@/views/Dashboard/SocialTrafficTable';
  import PageVisitsTable from '@/views/Dashboard/PageVisitsTable';

  import { Table, TableColumn, Select, Option, DatePicker, Pagination } from 'element-ui';
  import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin'
  import { BasePagination } from '@/components';
  import Fuse from 'fuse.js';
  import ModalPdf from '@/views/Cart/ModalPdf.vue';
  import ModalFirma from '@/views/Cart/ModalFirma.vue';

  import IngresarNroVenta from '@/views/VentasPlanes/IngresarNroVenta.vue';

  import swal from 'sweetalert2';

  import ModalEditVenta from '@/views/VentasPlanes/ModalEditVenta.vue';

  export default {
    components: {
      BaseProgress,
      RouteBreadCrumb,
      StatsCard,
      PageVisitsTable,
      SocialTrafficTable,
      LightTable,
      BasePagination,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [DatePicker.name]: DatePicker,
      [Pagination.name]: Pagination,
      ModalPdf,
      ModalFirma,
      IngresarNroVenta,
      ModalEditVenta
    },
    data() {
      return {
        search: '',
        totalPages: 1,
        perPage: 100,
        perPageList: [10,50,100,500],
        currentPage: 1,
        dateRangeFilter: '',
        pickerOptions2: {
          shortcuts: [{
            text: 'Última semana',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Último mes',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Últimos 3 meses',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        propsToSearch: ['estado', 'plan'],
        tableColumns: [
        ],
        arregloPuedeConfirmar: [],
        arregloRequiereFirma: [],
        arregloRequiereVenta: [],
        tableData: [],
        selectedRows: [],
      };
    },
    computed: {
    },
    methods: {
      eliminarVenta(row){
        swal({
          title: 'Estás seguro?',
          text: `Si la venta tiene siniestros, primero se tienen que eliminar sus siniestros`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Si',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            var vm = this;
            
            console.log(row);
            this.axios({
              url: 'api/ventas/eliminar',
              method: 'POST',
              data: {
                venta_id: row.id
              }
            }).then( response => {
              vm.fetchData();
              swal({
                title: 'Venta Eliminada!',
                text: `Has eliminado la venta ID: ${row.id}`,
                type: 'success',
                confirmButtonClass: 'btn btn-success btn-fill',
                buttonsStyling: false
              });
            }).catch( error => {
              console.log(error);
              vm.$notify({ type: 'danger', message: error.response.data});
            });
            
          }
        });
      },
      
      selectionChange(selectedRows) {
        this.selectedRows = selectedRows
      },
      verContrato(venta)
      {
          this.$emit('loadModalPdf', venta);
      },
      ingresarFirma(venta_id)
      {
          this.$emit('loadModalFirma', venta_id);
      },
      ingresarNroVenta(venta_id)
      {
        this.$emit('loadModalNroVenta', venta_id);
      },

      confirmarVenta(venta_id)
      {

        var vm = this;
        swal({
          title: 'Estás segur@?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Si, vamos!',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.axios({
              method: 'POST',
              url: 'api/ventas/confirm_purchase',
              data: {
                venta: venta_id
              }
            }).then( response => {
              vm.fetchData();
              vm.$notify({
                message: 'Venta confirmada correctamente',
                type: 'success'
              });
            }).catch( error => {
              vm.$notify({
                message: 'Hubo un error, no se pudo confirmar la venta',
                type: 'danger'
              });
              console.log(error);
            });
          }
        });
            
      },
      fetchData()
      {
        var vm = this;
        this.axios({
          url: 'api/ventas/data_management',
          params:{
            search: this.search,
            perPage: this.perPage,
            currentPage: this.currentPage,
            startDate: Array.isArray(this.dateRangeFilter) ? this.$moment(this.dateRangeFilter[0]).format('YYYY-MM-DD') : null,
            endDate: Array.isArray(this.dateRangeFilter) ? this.$moment(this.dateRangeFilter[1]).format('YYYY-MM-DD') : null
          },
          method: 'GET',
        }).then(response => {
          
          let columnas;
          if( response.data.dataTable.data.length > 0 ) columnas = Object.getOwnPropertyNames(response.data.dataTable.data[0]);
          vm.tableData = response.data.dataTable.data.map( (e, iiindice) => ({ ...e, confirmar: response.data.arregloConfirmar[iiindice], requiere_firma: response.data.arregloRequiereFirma[iiindice]  , requiere_venta: response.data.arregloRequiereVenta[iiindice] }) );
          vm.propsToSearch = columnas;
          vm.totalPages = response.data.totalPages;
          vm.currentPage = response.data.currentPage;
          vm.tableColumns = [];
          vm.tableColumns.push({ type: 'selection' });
          columnas.forEach( item => {
            vm.tableColumns.push({ prop: item, label: item, sortable: true,  });
          } );
        }).catch( error => {
          console.log(error);
        });
      }
    },
    mounted() {
      this.fetchData();
    }
  };
</script>
<style></style>
